"use client";

import ApiDocumentation from './components/ApiDocumentation';
import PageDecoration from '../components/PageDecoration';

export default function ApiDoc() {
  return (
    <main>
      <PageDecoration />
      <ApiDocumentation />
    </main>
  );
} 